export const SET_PIECE_TO_BREAK_PARENT =
  'VIEW_PIECES/SET_PIECE_TO_BREAK_PARENT';
export const UNSET_PIECE_TO_BREAK_PARENT =
  'VIEW_PIECES/UNSET_PIECE_TO_BREAK_PARENT';

export const SET_PIECES_ORDER_BY = 'VIEW_PIECES/SET_PIECES_ORDER_BY';

export const REQUEST_SHARE_LINK = 'VIEW_PIECES/SHARE/REQUEST';
export const RESPONSE_SHARE_LINK = 'VIEW_PIECES/SHARE/RESPONSE';
